!(function () {
  let radio, subcategoriesSwiper;
  const init = function () {
    const selectViewForm = document.getElementById("collection-mobile-display");
    if (selectViewForm) {
      radio = selectViewForm.elements["collection-mobile-display"];
      selectViewForm.addEventListener("change", updateDisplay);
      updateDisplay();
    }
    initSwiper();
    window.addEventListener("resize", initSwiper);
    window.scrollTo({ top: 0 });
  };
  const initSwiper = function () {
    const slidesEl = document.getElementById("collection-subcategories-slides");
    const swiperEl = document.getElementById("collection-subcategories-swiper");
    const slidesCount = slidesEl.querySelectorAll(".slide").length;
    if (!slidesEl) {
      return;
    }
    const swiperParent = swiperEl.closest(".subcategories-swiper-outer");
    swiperParent.classList.add("hidden");
    if (window.innerWidth >= 768) {
      if (!subcategoriesSwiper) {
        const swiperParams = {
          slidesPerView: 3,
          spaceBetween: 1,
          breakpoints: {
            860: {
              slidesPerView: Math.min(4, slidesCount),
              slidesPerGroup: 1,
            },
            1280: {
              slidesPerView: Math.min(6, Math.max(slidesCount, 3)),
              slidesPerGroup: Math.min(4, Math.max(slidesCount, 3)),
            },
            1340: {
              slidesPerView: Math.min(8, Math.max(slidesCount, 4)),
              slidesPerGroup: Math.min(4, Math.max(slidesCount, 3)),
            },
            1536: {
              slidesPerView: Math.min(10, Math.max(slidesCount, 4)),
              slidesPerGroup: Math.min(4, Math.max(slidesCount, 3)),
            },
          },
          injectStyles: [
            `
            :host .swiper {
              padding-bottom: 1rem;
            }
            :host .swiper-scrollbar-drag {
              cursor:grab;
            }
            `,
          ],
          navigation: {
            nextEl: "#collection-subcategories-next",
            prevEl: "#collection-subcategories-prev",
            disabledClass: "opacity-0",
          },
          scrollbar: { draggable: !0 },
          on: {
            init: function (s) {
              const slides = slidesEl.querySelectorAll(".slide");
              slides.forEach((slide) => {
                const swiperSlide = document.createElement("swiper-slide");
                swiperSlide.innerHTML = slide.innerHTML;
                swiperEl.appendChild(swiperSlide);
              });
              subcategoriesSwiper = s;
              console.log("init", subcategoriesSwiper);
              swiperParent.classList.remove("hidden");
            },
          },
        };
        Object.assign(swiperEl, swiperParams);
        swiperEl.initialize();
      }
    }
    swiperParent.classList.remove("hidden");
  };
  const updateDisplay = function (event) {
    const subcategoriesUi = document.getElementById("collection-subcategories");
    const productsUi = document.getElementById("ProductGridContainer");
    const radio = document.getElementById("collection-mobile-display").elements["collection-mobile-display"];
    const newVal = radio.value;
    if (newVal === "subcategories") {
      subcategoriesUi.classList.remove("hidden");
      productsUi.classList.add("hidden");
    } else {
      subcategoriesUi.classList.add("hidden");
      productsUi.classList.remove("hidden");
    }
    window.scrollTo({ top: 0 });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
